<div scrollbarWithEndingBlinds
  class="dropdown-menu_list"
  [updateOn]="changeDetectionSafeItemsUpdate$">

  @for (menuItem of menuItems; track menuItem; let i = $index) {
    <li class="dropdown-menu_item"
      (click)="onMenuItemClick(menuItem)"
      [class.-separator]="menuItem.isSeparator"
      [class.-hover]="i === preselectedMenuItemIndex"
      [tooltipL10n]="menuItem.labelLong !== menuItem.label ? menuItem.labelLong : ''"
      #item>
      @if (!menuItem.isSeparator) {
        <span>{{menuItem.label | l10n}}</span>
      } @else {
        <hr />
      }
    </li>
  }

</div>
